import React from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import Header from './partials/header'
import Categories from './partials/categories'

export const CategoryProductCarousels = ({
    title,
    titleFontFamily = 'caslon',
    titleColor = 'black',
    titleTag = 'h2',
    titleAlignment = 'center',
    productShowName,
    productShowPrice,
    productShowColorSwatches,
    categoryTitle1,
    categoryFilters1,
    categoryId1,
    productList1,
    categoryTitleFontFamily1 = 'inter',
    categoryTitleAlignment1M = 'center',
    categoryTitleAlignment1D = 'center',
    categoryTitle2,
    categoryFilters2,
    categoryId2,
    productList2,
    categoryTitleFontFamily2 = 'inter',
    categoryTitleAlignment2M = 'center',
    categoryTitleAlignment2D = 'center',
    categoryTitle3,
    categoryFilters3,
    categoryId3,
    productList3,
    categoryTitleFontFamily3 = 'inter',
    categoryTitleAlignment3M = 'center',
    categoryTitleAlignment3D = 'center',
    typeId,
    name,
    enableLifeStyleTile1 = false,
    lifeStyleCopyText1,
    enableLifeStyleCopyTextUnderline1 = false,
    lifeStyleFontColor1,
    lifeStyleBackgroundColor1,
    lifeStyleImage1,
    lifeStyleVideo1,
    lifeStyleAlt1,
    lifeStyleCategoryUrl1,
    lifeStylePosition1,
    enableLifeStyleTile2 = false,
    lifeStyleCopyText2,
    enableLifeStyleCopyTextUnderline2 = false,
    lifeStyleFontColor2,
    lifeStyleBackgroundColor2,
    lifeStyleImage2,
    lifeStyleVideo2,
    lifeStyleAlt2,
    lifeStyleCategoryUrl2,
    lifeStylePosition2,
    enableLifeStyleTile3 = false,
    lifeStyleCopyText3,
    enableLifeStyleCopyTextUnderline3 = false,
    lifeStyleFontColor3,
    lifeStyleBackgroundColor3,
    lifeStyleImage3,
    lifeStyleVideo3,
    lifeStyleAlt3,
    lifeStyleCategoryUrl3,
    lifeStylePosition3
}) => {
    const categories = [
        {
            title: categoryTitle1,
            fontFamily: categoryTitleFontFamily1 || 'inter',
            id: categoryId1,
            productsList: productList1?.split(','),
            categoryFilters: categoryFilters1,
            mobileAlignment: categoryTitleAlignment1M,
            desktopAlignment: categoryTitleAlignment1D,
            lifeStyle: {
                enable: enableLifeStyleTile1,
                copyText: lifeStyleCopyText1,
                enableCopyTextUnderline: enableLifeStyleCopyTextUnderline1,
                fontColor: lifeStyleFontColor1,
                backgroundColor: lifeStyleBackgroundColor1,
                imageUrl: lifeStyleImage1,
                videoUrl: lifeStyleVideo1,
                alt: lifeStyleAlt1,
                categoryUrl: lifeStyleCategoryUrl1,
                position: lifeStylePosition1
            }
        },
        {
            title: categoryTitle2,
            fontFamily: categoryTitleFontFamily2 || 'inter',
            id: categoryId2,
            productsList: productList2?.split(','),
            categoryFilters: categoryFilters2,
            mobileAlignment: categoryTitleAlignment2M,
            desktopAlignment: categoryTitleAlignment2D,
            lifeStyle: {
                enable: enableLifeStyleTile2,
                copyText: lifeStyleCopyText2,
                enableCopyTextUnderline: enableLifeStyleCopyTextUnderline2,
                fontColor: lifeStyleFontColor2,
                backgroundColor: lifeStyleBackgroundColor2,
                imageUrl: lifeStyleImage2,
                videoUrl: lifeStyleVideo2,
                alt: lifeStyleAlt2,
                categoryUrl: lifeStyleCategoryUrl2,
                position: lifeStylePosition2
            }
        },
        {
            title: categoryTitle3,
            fontFamily: categoryTitleFontFamily3 || 'inter',
            id: categoryId3,
            productsList: productList3?.split(','),
            categoryFilters: categoryFilters3,
            mobileAlignment: categoryTitleAlignment3M,
            desktopAlignment: categoryTitleAlignment3D,
            lifeStyle: {
                enable: enableLifeStyleTile3,
                copyText: lifeStyleCopyText3,
                enableCopyTextUnderline: enableLifeStyleCopyTextUnderline3,
                fontColor: lifeStyleFontColor3,
                backgroundColor: lifeStyleBackgroundColor3,
                imageUrl: lifeStyleImage3,
                videoUrl: lifeStyleVideo3,
                alt: lifeStyleAlt3,
                categoryUrl: lifeStyleCategoryUrl3,
                position: lifeStylePosition3
            }
        }
    ]
    const shouldRender = categories.some(
        (category) => category.title && (category.id || category.productsList)
    )

    const analyticsProps = {
        component_id: typeId,
        component_name: title || name || typeId
    }

    return (
        shouldRender && (
            <Stack marginBottom="20px" gap={{base: '10px', lg: 0}}>
                <Header
                    title={title}
                    titleFontFamily={titleFontFamily}
                    titleColor={titleColor}
                    titleTag={titleTag}
                    titleAlignment={titleAlignment}
                />

                <Categories
                    categories={categories}
                    productShowName={productShowName}
                    productShowPrice={productShowPrice}
                    productShowColorSwatches={productShowColorSwatches}
                    analyticsProps={analyticsProps}
                    showMetalLabel={false}
                />
            </Stack>
        )
    )
}

CategoryProductCarousels.propTypes = {
    title: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleColor: PropTypes.string,
    titleAlignment: PropTypes.string,
    pageData: PropTypes.any,
    titleTag: PropTypes.string,
    productShowName: PropTypes.bool,
    productShowPrice: PropTypes.bool,
    productShowColorSwatches: PropTypes.bool,
    categoryTitle1: PropTypes.string,
    categoryTitleFontFamily1: PropTypes.string,
    categoryTitleAlignment1M: PropTypes.string,
    categoryTitleAlignment1D: PropTypes.string,
    categoryId1: PropTypes.string,
    productList1: PropTypes.string,
    categoryTitle2: PropTypes.string,
    categoryTitleFontFamily2: PropTypes.string,
    categoryTitleAlignment2M: PropTypes.string,
    categoryTitleAlignment2D: PropTypes.string,
    categoryId2: PropTypes.string,
    productList2: PropTypes.string,
    categoryTitle3: PropTypes.string,
    categoryTitleFontFamily3: PropTypes.string,
    categoryTitleAlignment3M: PropTypes.string,
    categoryTitleAlignment3D: PropTypes.string,
    categoryId3: PropTypes.string,
    productList3: PropTypes.string,
    categoryFilters1: PropTypes.any,
    categoryFilters2: PropTypes.any,
    categoryFilters3: PropTypes.any,
    typeId: PropTypes.string,
    name: PropTypes.string,
    enableLifeStyleTile1: PropTypes.bool,
    lifeStyleCopyText1: PropTypes.string,
    enableLifeStyleCopyTextUnderline1: PropTypes.string,
    lifeStyleFontColor1: PropTypes.string,
    lifeStyleBackgroundColor1: PropTypes.string,
    lifeStyleImage1: PropTypes.string,
    lifeStyleVideo1: PropTypes.string,
    lifeStyleAlt1: PropTypes.string,
    lifeStyleCategoryUrl1: PropTypes.any,
    lifeStylePosition1: PropTypes.string,
    enableLifeStyleTile2: PropTypes.bool,
    lifeStyleCopyText2: PropTypes.string,
    enableLifeStyleCopyTextUnderline2: PropTypes.string,
    lifeStyleFontColor2: PropTypes.string,
    lifeStyleBackgroundColor2: PropTypes.string,
    lifeStyleImage2: PropTypes.string,
    lifeStyleVideo2: PropTypes.string,
    lifeStyleAlt2: PropTypes.string,
    lifeStyleCategoryUrl2: PropTypes.any,
    lifeStylePosition2: PropTypes.string,
    enableLifeStyleTile3: PropTypes.bool,
    lifeStyleCopyText3: PropTypes.string,
    enableLifeStyleCopyTextUnderline3: PropTypes.string,
    lifeStyleFontColor3: PropTypes.string,
    lifeStyleBackgroundColor3: PropTypes.string,
    lifeStyleImage3: PropTypes.string,
    lifeStyleVideo3: PropTypes.string,
    lifeStyleAlt3: PropTypes.string,
    lifeStyleCategoryUrl3: PropTypes.any,
    lifeStylePosition3: PropTypes.string
}

export default CategoryProductCarousels
